import {compatibilites} from './compatibilities';

const testVersionsCompatibility = versions => {
	const {tests, warnings} = testVersionsCompatibilityWithCompatibilities({compatibilites, versions});
	warnings.forEach(({type, mess}) => {
		if(type == 'warn'){
			console.warn('SE', mess);
		}
		if(type == 'error'){
			console.error('SE', mess);
		}
	});
	return {tests, warnings};
}

export const testVersionsCompatibilityWithCompatibilities = ({compatibilites, versions}) => {
	const result = {
		warnings: [],
		tests: {},
	}
	Object.entries(versions).forEach(([type, version]) => {
		testCompatibilityForType({compatibilites, versions, type, version, result});
	});
	return result;
}

const testCompatibilityForType = ({compatibilites, versions, type, version, result}) => {
	
	const compatibilityForType = compatibilites[type];
	if(!compatibilityForType){
		result.tests[type] = false;
		result.warnings.push({
			type: 'warn',
			mess: `Compatibilities for ${type} not found.`,
		});
		return;
	}
	
	const compatibilityForTypeVersion = compatibilityForType[version];
	if(!compatibilityForTypeVersion){
		result.tests[type] = false;
		result.warnings.push({
			type: 'warn',
			mess: `Compatibilities for ${type} exist, but not found for requested version: ${version}.`,
		});
		return;
	}

	const resultForType = result.tests[type] = {};
	Object.entries(compatibilityForTypeVersion).forEach(([pairType, pairVersionsCompatible]) => {
		if(type == pairType){ // same type
			return;
		}
		testPair({versions, type, version, result, resultForType, pairType, pairVersionsCompatible});
	});

	return result;
}

const testPair = ({versions, type, version, result, resultForType, pairType, pairVersionsCompatible}) => {

	const pairVersionRequested = versions[pairType];
	if(!pairVersionRequested){ // pair is not requested (i.e. url is not used), nothing to check, continue
		return;
	}
	
	if(!pairVersionsCompatible.includes(pairVersionRequested)){
		resultForType[pairType] = false;
		result.warnings.push({
			type: 'error',
			mess: `Requested incompatible version of ${pairType} (${pairVersionRequested}) for ${type} version ${version}.`,
		});
		return;
	}
	
	resultForType[pairType] = true;
}

export default testVersionsCompatibility;